import { GitHubProfile } from "shared/interfaces";
import { getExperienceYears } from "shared/utils/experience";
import { useTranslation } from "react-i18next";
import * as S from "./style";

interface IntroductionProps {
  userInfo: Partial<GitHubProfile>;
}

const Introduction = ({ userInfo }: IntroductionProps) => {
  const { t } = useTranslation("home");

  return (
    <S.Container $hasImage={!!userInfo.avatar_url}>
      {userInfo.avatar_url && (
        <S.Image
          src={userInfo.avatar_url}
          alt={t("profileImageAlt")}
          loading="lazy"
        />
      )}
      <S.Copy>
        <S.Title>{t("introduction")}</S.Title>
        <S.Text>
          <strong>
            {t("introductionName", { years: getExperienceYears() })}.
          </strong>{" "}
          {t("introductionInfo")}
        </S.Text>
      </S.Copy>
    </S.Container>
  );
};

export default Introduction;
